import React from "react";
import Popup from "reactjs-popup";
import SpinInput from "../inputs/SpinInput";
import "./demander-tranche-age.css";
import Translator from "../translator";
import {useParams} from "react-router-dom";

const DemanderTrancheAge = (props) => {
    const {language} = useParams();
    const TEXTS = Translator(language, "TXT_DEMANDE_TRANCHE_AGE");
    const onTrancheAgeChange = (event) => {
        const ta = props.trancheAges.map((tranche) => {
            if ((tranche.trancheAge?.idTrancheAge || tranche.idTrancheAge) === event.target.name) return {...tranche, nombrePersonnes: event.target.value, quantite: event.target.value};
            return {...tranche, quantite: tranche.quantite || tranche.nombrePersonne || 0, nombrePersonnes: tranche.quantite || tranche.nombrePersonne || 0};
        });
        props.onValueChange(ta);
    };
    const orderedTrancheAges = props.trancheAges.sort((a, b) => {
        const tranche1 = a.trancheAge || a;
        const tranche2 = b.trancheAge || b;
        return tranche2.isAdulte - tranche1.isAdulte || tranche2.ageDebut - tranche1.ageDebut
    });
    return (<div>
        <Popup on="click" open={ props.isOpen } onClose={ props.handleClose } modal={ true } closeOnDocumentClick={ false } nested className="popup-tranche-age">
            <div className="tranche-age-header">
                <h3>{ TEXTS.titre }</h3>
            </div>
            <div className="tranche-age">
                { orderedTrancheAges.map((trancheAge) => {
                    const tranche = trancheAge.trancheAge || trancheAge;
                    if (tranche.idTrancheAge === "00000000-0000-0000-0000-000000000000" || !tranche.actif)
                        return <></>;

                    return (<div className="tranche-age-row" key={ tranche.idTrancheAge }>
                            <span>{ `${ tranche.isAdulte ? TEXTS.adultes : TEXTS.enfants }: ${ tranche.ageDebut }${ tranche.ageFin >= 999 ? ` ${ TEXTS.et_plus }` : ` ${ TEXTS.a } ${ tranche.ageFin }` }` }</span>
                            <SpinInput min={ 0 } name={ tranche.idTrancheAge } value={ trancheAge.quantite || tranche.nombrePersonne || 0 } onChange={ onTrancheAgeChange }></SpinInput>
                        </div>
                    );
                }) }
            </div>
            <div className="tranche-age-button">
                <button
                    onClick={ (event) => {
                        props.handleClose();
                        props.onConfirmation(props.unite.id_unite);
                    } }
                >
                    Ok
                </button>
                <button onClick={ () => props.handleClose(true) }>{ TEXTS.annuler }</button>
            </div>
        </Popup>
    </div>);
};

export default DemanderTrancheAge;
